import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reservationApi } from '@/api/reservations';

/**
 * React Query mutation hook to cancel a reservation
 */
export function useCancelReservation(storeDomain: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reservationUuid: string) => {
      if (!storeDomain) {
        throw new Error('Store domain is required');
      }
      return reservationApi.cancelReservation(storeDomain, reservationUuid);
    },
    onSuccess: (_data, reservationUuid) => {
      queryClient.invalidateQueries({
        queryKey: ['reservation', storeDomain, reservationUuid],
      });
    },
    retry: false,
  });
}
